import { Controller } from "@hotwired/stimulus"
import Pikaday from 'pikaday'

// Connects to data-controller="activities-pika"
export default class extends Controller {
  connect() {
    const activitiesPicker = new Pikaday({
      field: document.getElementById('timetables_item_search_date'),
      bound: false,
      container: document.getElementById('activities-calendar'),
    });
  }
}
